
import { DocumentPageSettings } from "@/utils/documents/page-settings";
import Vue from "vue";
import AppPageSettingsBackgroundImage from "../document-settings/PageSettingsBackgroundImage.vue";
import AppPageSettingsDefault from "../document-settings/PageSettingsDefault.vue";
import AppPageSettingsFont from "../document-settings/PageSettingsFont.vue";
import AppDefaultLanguage from "./DefaultLanguage.vue";

export default Vue.extend({
	props: {
		layout: Object as () => DocumentPageSettings
	},
	components: {
		AppPageSettingsBackgroundImage,
		AppPageSettingsDefault,
		AppPageSettingsFont,
		AppDefaultLanguage
	},
	i18nEx: {
		componentPrefix: "components.layout-editor-PageSettings"
	}
});
